module.exports = __webpack_public_path__ + "img/delete.aa4f2d34.svg";